<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Sea Import</b-navbar-brand>
          <div class="box-header" style="margin-left: auto">
            <!-- v-if="noteModal.fclBlId != '' && this.$sessionsStorage.get('designation') == 'Admin' && originalDone==true" -->
            <!-- <b-button
                style="margin-left: 5px"
                @click="openNoteModal(2)"
                size="sm"
                variant="warning"
                >Debit Note</b-button
              > -->
            <!-- <b-button
                style="margin-left: 5px"
                @click="openNoteModal(1)"
                size="sm"
                variant="warning"
                >Credit Note</b-button
              > -->
            <b-button
              @click="sendMANIFESTATION"
              size="sm"
              variant="warning"
              style="margin-left: 5px"
              >SEND MANIFESTATION DETAILS</b-button
            >
          </div>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="this.ALLMODULE ? this.ALLMODULE : ''"
          :jobSeriesBanner="this.JOBSERIES ? this.JOBSERIES : ''"
          :bannerClientName="this.CLIENTNAME ? this.CLIENTNAME : ''"
          iconId="fa fa-ship"
          :prbr_id="this.prbr_id?this.prbr_id:''"
        />
        <b-card class="formCard">
          <b-card-text>
            <!-- <md-layout md-gutter class="gutr">
              <md-layout md-flex="90"></md-layout>
              <md-layout md-flex="10">
                <md-button
                  v-if="ffExoprtDetail.ffImportId!=''"
                  @click="addStatus"
                  style="position: fixed;z-index:999;top:83%;"
                  class="md-fab"
                >
                  <md-icon>message</md-icon>
                </md-button>
              </md-layout>
            </md-layout> -->
            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="containerInfo">FF Activity</label>
                <model-list-select
                  isDisabled
                  :list="containerInfoList"
                  v-model="ffExoprtDetail.containerInfo"
                  option-value="containerInfoVal"
                  option-text="containerInfoText"
                  placeholder="Select Container Load"
                ></model-list-select>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>
                <model-list-select
                  :list="deliveryTermsList"
                  v-model="ffExoprtDetail.deliveryTerms"
                  option-value="deliveryTermsVal"
                  option-text="deliveryTermsText"
                  placeholder="Select Delivery Terms"
                ></model-list-select>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->

              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="stuffingType">De-Stuffing Type</label>
                <model-list-select
                  :list="stuffingTypeName"
                  v-model="ffExoprtDetail.stuffingType"
                  option-value="stuffingTypeVal"
                  option-text="stuffingTypeText"
                  placeholder="Select Type"
                ></model-list-select>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="agentName">Agent Name</label>
                <model-list-select
                  :list="getagentName"
                  v-model="ffExoprtDetail.agentName"
                  option-value="agntColoaderId"
                  option-text="agentName"
                  placeholder="Select Agent Name"
                ></model-list-select>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="clientId">Importer Name</label>

                <model-list-select
                  isDisabled
                  :list="clientList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.importerClientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Importer Name"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.importerClientId">{{
                  ffExporterrorList.importerClientId
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="exporterName">Exporter Name</label>
                <model-list-select
                  isDisabled
                  :list="clientList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.exporterClientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Exporter Name"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.exporterClientId">{{
                  ffExporterrorList.exporterClientId
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="bookingParty">Booking Party</label>
                <model-list-select
                  :list="bookingPartyList"
                  v-model="ffExoprtDetail.bookingParty"
                  option-value="billingPartyVal"
                  option-text="billingPartyTxt"
                  placeholder="Select Booking Party"
                ></model-list-select>
              </md-layout>
              <!-- <md-layout
                md-flex="5"
                v-if="ffExoprtDetail.bookingParty == 'Other'"
              ></md-layout> -->

              <md-layout
                md-flex="50"
                class="pl-2 pr-2"
                v-if="ffExoprtDetail.bookingParty == 'Other'"
              >
                <label for="sourceOriginclientId">Client Name (Booking Party)</label>
                <model-list-select
                  :list="clientList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.sourceOriginclientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Client Name"
                ></model-list-select>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout
                md-flex="50"
                class="pl-2 pr-2"
                v-if="ffExoprtDetail.containerInfo == 'lcl'"
              >
                <label for="agentName">CoLoader Name</label>
                <model-list-select
                  :list="getColoaderNameList"
                  v-model="ffExoprtDetail.coLoaderName"
                  option-value="agntColoaderId"
                  option-text="coLoaderName"
                  placeholder="Select Coloader "
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.coLoaderName">{{
                  ffExporterrorListLCL.coLoaderName
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Place Of Receipt</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    disabled
                    id="placeOfReceipt"
                    name="placeOfReceipt"
                    v-model="ffExoprtDetail.placeOfReceipt"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Load Port</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="loadPort"
                    name="loadPort"
                    disabled
                    v-model="ffExoprtDetail.loadPort"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Port Of Discharge</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    disabled
                    id="portOfDischarge"
                    name="portOfDischarge"
                    v-model="ffExoprtDetail.portOfDischarge"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Final Place Of Delivery</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    disabled
                    id="finalPlaceDelivery"
                    name="finalPlaceDelivery"
                    v-model="ffExoprtDetail.finalPlaceDelivery"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label>SOB Date:<span class="error">*</span></label>
                <date-picker
                  width="100%"
                  :format="selectDateFormat"
                  lang="en"
                  id="sailDate"
                  name="sailDate"
                  v-model="ffExoprtDetail.sailDate"
                ></date-picker>
                <span class="error" v-if="!ffExoprtDetail.sailDate">{{
                  errorCustomValidation.sailDate
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label>Pre-Alert Received Date:<span class="error">*</span></label>
                <date-picker
                  width="100%"
                  :format="selectDateFormat"
                  lang="en"
                  id="alertReceivedDate"
                  name="alertReceivedDate"
                  v-model="ffExoprtDetail.alertReceivedDate"
                ></date-picker>
                <span class="error" v-if="!ffExoprtDetail.alertReceivedDate">{{
                  errorCustomValidation.alertReceivedDate
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label>IGM Manifestation Date:<span class="error">*</span></label>
                <date-picker
                  width="100%"
                  :format="selectDateFormat"
                  lang="en"
                  :not-after="new Date()"
                  id="igmManifestationDate"
                  name="igmManifestationDate"
                  v-model="ffExoprtDetail.igmManifestationDate"
                ></date-picker>
                <span class="error" v-if="!ffExoprtDetail.igmManifestationDate">{{
                  errorCustomValidation.igmManifestationDate
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label>Vessel ETA Date:<span class="error">*</span></label>
                <date-picker
                  width="100%"
                  :format="selectDateFormat"
                  lang="en"
                  id="vesselEtaDate"
                  name="vesselEtaDate"
                  v-model="ffExoprtDetail.vesselEtaDate"
                ></date-picker>
                <span class="error" v-if="!ffExoprtDetail.vesselEtaDate">{{
                  errorCustomValidation.vesselEtaDate
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Free Days at India Port</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="freeDaysIndiaPort"
                    name="freeDaysIndiaPort"
                    type="number"
                    min="0"
                    v-model="ffExoprtDetail.freeDaysIndiaPort"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->

              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="deliveryMode">Destination Handling Fees By</label>
                <model-list-select
                  :list="destiHandleList"
                  v-model="ffExoprtDetail.destinationHandling"
                  option-value="DHVal"
                  option-text="DHText"
                  placeholder="Select Destination Handling Fees By"
                ></model-list-select>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="25" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>B/L Number:<span class="error">*</span></label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="firstBLNumber"
                    name="firstBLNumber"
                    v-model="ffExoprtDetail.firstBLNumber"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!ffExoprtDetail.firstBLNumber">{{
                  errorCustomValidation.firstBLNumber
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->

              <md-layout md-flex="25" class="pl-2 pr-2">
                <label for="firstBlType">B/L Type:<span class="error">*</span></label>
                <model-list-select
                  :list="
                    ffExoprtDetail.containerInfo == 'fcl' ? blTypeList : blTypeListLcl
                  "
                  v-model="ffExoprtDetail.firstBlType"
                  option-value="blTypeVal"
                  option-text="blTypeTxt"
                  placeholder="Select B/L Type"
                  isDisabled
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.firstBlType">{{
                  errorCustomValidation.firstBlType
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label>B/L Date:<span class="error">*</span></label>
                <date-picker
                  width="100%"
                  :format="selectDateFormat"
                  lang="en"
                  id="firstBLDate"
                  name="firstBLDate"
                  v-model="ffExoprtDetail.firstBLDate"
                ></date-picker>
                <span class="error" v-if="!ffExoprtDetail.firstBLDate">{{
                  errorCustomValidation.firstBLDate
                }}</span>
              </md-layout>

              <md-layout md-flex="25" class="pl-2 pr-2">
                <label for="deliveryTerms">Ocean Freight</label>
                <model-list-select
                  :list="oceanFreightTermsList"
                  v-model="ffExoprtDetail.firstOcFreghtTerms"
                  option-value="oceanFreightTermsVal"
                  option-text="oceanFreightTermsText"
                  placeholder="Select Ocean Freight"
                ></model-list-select>
              </md-layout>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-gutter class="mt-3">
              <md-layout md-flex="10" class="pl-2 pr-2">
                <md-radio
                  style="margin: 0 !important"
                  id="permitted1"
                  name="permitted1"
                  md-value="Original"
                  v-model="ffExoprtDetail.firstBLRadio"
                  class="md-primary"
                  >Original</md-radio
                >
              </md-layout>

              <md-layout md-flex="15" class="pl-2 pr-2">
                <md-radio
                  style="margin: 0 !important"
                  id="permitted2"
                  name="permitted2"
                  v-model="ffExoprtDetail.firstBLRadio"
                  md-value="seaWayBl"
                  class="md-primary"
                  >Sea Way B/L</md-radio
                >
                <span class="error" v-if="!ffExoprtDetail.firstBLRadio">{{
                  ffExporterrorList.firstBLRadio
                }}</span>
              </md-layout>
              <b-button
                class="ml-auto mr-2"
                size="sm"
                @click="showDocModal"
                variant="dark"
                >Upload B/L</b-button
              >

              <!-- <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-input-container>
                  <label>Upload B/L</label>
                  <md-file
                    name="firstBLupload"
                    id="firstBLupload"
                    v-model="ffExoprtDetail.firstBLupload"
                    @selected="onFileChange('FIRST')"
                    multiple
                  ></md-file>
                </md-input-container>
              </md-layout> -->
            </md-layout>
            <md-layout md-gutter v-if="firstBlUploadView.length > 0">
              <md-layout md-flex="80"></md-layout>
              <md-layout
                md-flex="15"
                v-for="(item, index) in firstBlUploadView"
                :key="index"
              >
                <!-- :href="`${docURL}/FF_Sea_Import_Uploads/` + item" -->
                <a :href="`${docURL}/` + item" target="_blank" download
                  >View Document - {{ index + 1 }}</a
                >
              </md-layout>
            </md-layout>

            <md-layout gutter v-if="ffExoprtDetail.firstBLRadio == 'Original'">
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label>Surrender Date</label>
                <date-picker
                  width="100%"
                  :format="selectDateFormat"
                  lang="en"
                  id="secondBLDate"
                  name="secondBLDate"
                  v-model="ffExoprtDetail.surrenderDate"
                ></date-picker>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label>Original BL Received Date</label>
                <date-picker
                  width="100%"
                  :format="selectDateFormat"
                  lang="en"
                  id="originalBlRecDate"
                  name="originalBlRecDate"
                  v-model="ffExoprtDetail.originalBlRecDate"
                ></date-picker>
              </md-layout>
            </md-layout>
            <md-layout gutter>
              <md-layout
                md-flex="100"
                class="pl-2 pr-2"
                v-for="(singleInputM, index) in ffExoprtDetail.notifyList"
                :key="index"
              >
                <md-layout md-flex="100">
                  <md-layout md-flex="60">
                    <label>{{ notifyArray[index] }} Notify Name & Address</label>
                  </md-layout>
                  <md-layout md-flex="15" v-if="index > 1">
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="removeNotifyMaster(index)"
                      style="min-height: 20px; height: 20px"
                    >
                      <md-icon>close</md-icon>
                    </md-button>
                  </md-layout>
                </md-layout>

                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      id="inputValue"
                      name="inputValue"
                      v-model="singleInputM.inputValue"
                    ></b-form-textarea>
                    <!-- <quill-editor ref="myTextEditor" v-model="singleInput.inputValue"></quill-editor> -->
                  </md-layout>
                </md-layout>
              </md-layout>
              <!-- <md-button style="margin-top:18px; height: 10px;  width: 39px;" class="md-fab md-fab">
              <md-icon>add</md-icon>
              </md-button>-->
            </md-layout>

            <md-layout gutter class="pl-2 pr-2">
              <b-button
                size="sm"
                class="mt-2"
                variant="outline-dark"
                @click="addNotifyMaster"
                >Add More Notify</b-button
              >

              <md-layout md-flex="30"></md-layout>
            </md-layout>
            <!-- <md-layout md-gutter v-if="getHouseBLData.length>0 &&  HouseBLModel.houseBLId=='' ">
          <md-layout md-flex="75"></md-layout>

          <md-layout md-flex="25">
            <h4
              @click="showMoreShipper"
              class="showMoreData"
            >Click here to {{openShipper==true?"Hide":"Add More"}} House BL</h4>
          </md-layout>
            </md-layout>-->
            <div>
              <div
                class="mt-2"
                v-if="
                  (getHouseBLData.length == 0 ||
                    openShipper == true ||
                    HouseBLModel.houseBLId != '') &&
                  ffExoprtDetail.otherNewContainerFLow == 0
                "
              >
                <b-card>
                  <md-layout md-gutter>
                    <md-layout md-flex="25" class="pl-2 pr-2">
                      <md-layout md-flex="100">
                        <label>B/L Number</label>
                        <b-form-input
                          :formatter="capitalizeAll"
                          id="secondBLNumber"
                          name="secondBLNumber"
                          v-model="HouseBLModel.secondBLNumber"
                        ></b-form-input>
                      </md-layout>
                      <span class="error" v-if="!HouseBLModel.secondBLNumber">{{
                        HouseBLModelError.secondBLNumber
                      }}</span>
                    </md-layout>

                    <!-- <md-layout md-flex="5"></md-layout> -->
                    <md-layout md-flex="25" class="pl-2 pr-2">
                      <label>B/L Date</label>
                      <date-picker
                        width="100%"
                        :format="selectDateFormat"
                        lang="en"
                        id="secondBLDate"
                        name="secondBLDate"
                        v-model="HouseBLModel.secondBLDate"
                      ></date-picker>
                      <span class="error" v-if="!HouseBLModel.secondBLDate">{{
                        HouseBLModelError.secondBLDate
                      }}</span>
                    </md-layout>

                    <md-layout md-flex="50" class="pl-2 pr-2">
                      <label for="secondBlType">B/L Type</label>
                      <!-- :isDisabled="ffExoprtDetail.firstBlType=='MasterBL'" -->
                      <model-list-select
                        :list="
                          ffExoprtDetail.containerInfo == 'fcl'
                            ? blTypeList
                            : blTypeListLcl
                        "
                        v-model="HouseBLModel.secondBlType"
                        option-value="blTypeVal"
                        option-text="blTypeTxt"
                        placeholder="Select B/L Type"
                      ></model-list-select>
                      <span class="error" v-if="!HouseBLModel.secondBlType">{{
                        HouseBLModelError.secondBlType
                      }}</span>
                    </md-layout>
                    <!-- <md-layout md-flex="5"></md-layout> -->
                  </md-layout>
                  <md-layout gutter>
                    <md-layout
                      md-flex="50"
                      v-for="(singleInput, index) in HouseBLModel.notifyList"
                      :key="index"
                    >
                      <md-layout md-flex="100" class="pl-2 pr-2">
                        <md-layout md-flex="60">
                          <label>{{ notifyArray[index] }} Notify Name & Address</label>
                        </md-layout>
                        <md-layout md-flex="15" v-if="index > 1">
                          <md-button
                            class="md-icon-button md-raised md-dense"
                            @click="removeNotify(index)"
                            style="min-height: 20px; height: 20px"
                          >
                            <md-icon>close</md-icon>
                          </md-button>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="100" class="pl-2 pr-2">
                        <!-- <md-layout md-flex="85"> -->
                        <b-form-textarea
                          :formatter="capitalizeAll"
                          id="inputValue"
                          name="inputValue"
                          v-model="singleInput.inputValue"
                        ></b-form-textarea>
                        <!-- <quill-editor ref="myTextEditor" v-model="singleInput.inputValue"></quill-editor> -->
                        <!-- </md-layout> -->
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout gutter>
                    <md-layout md-flex="30" class="pl-2 pr-2">
                      <b-button
                        size="sm"
                        class="mt-2"
                        variant="outline-dark"
                        @click="addNotify"
                        >Add More Notify</b-button
                      >

                      <md-spinner
                        md-indeterminate
                        id="loader1"
                        style="display: none"
                      ></md-spinner>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="align-items-end">
                    <md-layout md-flex="50" class="pl-2 pr-2">
                      <label for="secondOcFreghtTerms">Ocean Freight</label>
                      <model-list-select
                        :list="oceanFreightTermsList"
                        v-model="HouseBLModel.secondOcFreghtTerms"
                        option-value="oceanFreightTermsVal"
                        option-text="oceanFreightTermsText"
                        placeholder="Select Ocean Freight"
                      ></model-list-select>
                    </md-layout>

                    <!-- <md-layout md-flex="5"></md-layout> -->
                    <md-layout md-flex="10" class="pl-2 pr-2">
                      <md-radio
                        style="margin: 0 0 0.5rem 0"
                        id="permitted1"
                        name="permitted1"
                        md-value="Original"
                        v-model="HouseBLModel.secondBLRadio"
                        class="md-primary"
                        >Original</md-radio
                      >
                    </md-layout>

                    <md-layout md-flex="15" class="pl-2 pr-2">
                      <md-radio
                        style="margin: 0 0 0.5rem 0"
                        id="permitted2"
                        name="permitted2"
                        v-model="HouseBLModel.secondBLRadio"
                        md-value="seaWayBl"
                        class="md-primary"
                        >Sea Way B/L</md-radio
                      >
                      <span class="error" v-if="!HouseBLModel.secondBLRadio">{{
                        HouseBLModelError.secondBLRadio
                      }}</span>
                    </md-layout>
                    <!-- <md-layout md-flex="5"></md-layout> -->

                    <md-layout md-flex="25" class="pl-2 pr-2">
                      <md-layout md-flex="100">
                        <md-input-container>
                          <label>Upload B/L</label>
                          <md-file
                            name="secondBLupload"
                            id="secondBLupload"
                            v-model="HouseBLModel.secondBLupload"
                            @selected="onFileChange('SECOND', '', '')"
                            multiple
                          ></md-file>
                        </md-input-container>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter v-if="secondBlUploadView.length > 0">
                    <md-layout md-flex="80"></md-layout>
                    <md-layout
                      md-flex="15"
                      v-for="(item, index) in secondBlUploadView"
                      :key="index"
                    >
                      <!-- :href="`${docURL}/FF_Sea_Import_Uploads/` + item" -->
                      <a :href="`${docURL}/` + item" target="_blank" download
                        >View Document - {{ index + 1 }}</a
                      >
                    </md-layout>
                  </md-layout>
                  <md-layout gutter v-if="HouseBLModel.secondBLRadio == 'Original'">
                    <md-layout md-flex="25" class="pl-2 pr-2">
                      <label>Surrender Date</label>
                      <date-picker
                        width="100%"
                        :format="selectDateFormat"
                        lang="en"
                        id="secondBLDate"
                        name="secondBLDate"
                        v-model="HouseBLModel.surrenderDate"
                      ></date-picker>
                    </md-layout>
                    <!-- <md-layout md-flex="5"></md-layout> -->
                    <md-layout md-flex="25" class="pl-2 pr-2">
                      <label>Original BL Received Date</label>
                      <date-picker
                        width="100%"
                        :format="selectDateFormat"
                        lang="en"
                        id="originalBlRecDate"
                        name="originalBlRecDate"
                        v-model="HouseBLModel.originalBlRecDate"
                      ></date-picker>
                    </md-layout>
                  </md-layout>

                  <md-layout gutter>
                    <!-- <md-layout md-flex="90"></md-layout> -->

                    <md-layout class="justify-content-center">
                      <b-button
                        class="smbutnWidth mt-2"
                        variant="info"
                        size="sm"
                        id="addButtonLoader"
                        @click="addFFSeaImport('3')"
                        >{{
                          HouseBLModel.houseBLId == "" ? "Add" : "Update"
                        }}
                        BL</b-button
                      >
                      <md-spinner
                        md-indeterminate
                        id="loader3"
                        style="display: none"
                      ></md-spinner>
                    </md-layout>
                  </md-layout>
                </b-card>
              </div>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="15" v-if="ffExoprtDetail.otherNewContainerFLow == 1">
                  <b-button
                    variant="outline-dark"
                    size="sm"
                    @click="addAdditionalHBL"
                    class="md-fab md-fab"
                    >Add More HBL</b-button
                  >
                </md-layout>
              </md-layout>
              <!-- {{ getHouseBLData }} -->
              <div class="mt-3" v-if="getHouseBLData.length > 0">
                <div>
                  <h5>
                    <b-badge>House-BL Details</b-badge>
                  </h5>
                  <!-- // Added By Priyanshu SIngh Section Start -->
                  <b-card>
                    <div v-for="(item, index1) in getHouseBLData" :key="index1">
                      <md-layout md-gutter class="gutr">
                        <md-layout md-flex="40">
                          <label for="stuffingType">HBL No.</label>
                          <b-input
                            style="height: 37px"
                            name="securityAmount"
                            id="securityAmount"
                            v-model="item.secondBLNumber"
                          ></b-input>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="20">
                          <label>HBL Date</label>

                          <date-picker
                            :format="selectDateFormat"
                            lang="en"
                            id="receivedDo"
                            name="receivedDo"
                            v-model="item.secondBLDate"
                          ></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="20">
                          <label for="BlType">B/L Type</label>
                          <model-list-select
                            :list="
                              ffExoprtDetail.containerInfo == 'fcl'
                                ? blTypeList
                                : blTypeListLcl
                            "
                            v-model="item.secondBlType"
                            option-value="blTypeVal"
                            option-text="blTypeTxt"
                            placeholder="Select B/L Type"
                          ></model-list-select>
                        </md-layout>
                        <!-- {{ item.notifyList.length }} -->
                        <md-layout gutter v-if="item.notifyList.length > 0">
                          <md-layout
                            md-flex="100"
                            v-for="(singleInput, index) in item.notifyList"
                            :key="index"
                          >
                            <md-layout md-flex="100" class="pl-2 pr-2">
                              <md-layout md-flex="100">
                                <label
                                  >{{ notifyArray[index] }} Notify Name & Address</label
                                >
                              </md-layout>
                              <!-- <md-layout md-flex="15" v-if="index > 1">
                                <md-button
                                  class="md-icon-button md-raised md-dense"
                                  @click="removeNotifyHBL(index)"
                                  style="min-height: 20px; height: 20px"
                                >
                                  <md-icon>close</md-icon>
                                </md-button>
                              </md-layout> -->
                            </md-layout>

                            <md-layout md-flex="100" class="pl-2 pr-2">
                              <b-form-textarea
                                :formatter="capitalizeAll"
                                id="inputValue"
                                name="inputValue"
                                v-model="singleInput.inputValue"
                              ></b-form-textarea>
                            </md-layout>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                      <!-- <md-layout gutter>
                          <md-layout md-flex="30" class="pl-2 pr-2">
                            <b-button
                              size="sm"
                              class="mt-2"
                              variant="outline-dark"
                              @click="addNotifyHBL(index)"
                              >Add More Notify</b-button
                            >

                            <md-spinner
                              md-indeterminate
                              id="loader1"
                              style="display: none"
                            ></md-spinner>
                          </md-layout>
                        </md-layout> -->
                      <!-- class="align-items-end" -->
                      <md-layout md-gutter class="gutr">
                        <md-layout md-gutter>
                          <md-layout md-flex="20" class="pl-2 pr-2">
                            <label for="secondOcFreghtTerms">Ocean Freight</label>
                            <!-- {{item.secondOcFreghtTerms}} -->
                            <model-list-select
                              :list="oceanFreightTermsList"
                              v-model="item.secondOcFreghtTerms"
                              option-value="oceanFreightTermsVal"
                              option-text="oceanFreightTermsText"
                              placeholder="Select Ocean Freight"
                            ></model-list-select>
                          </md-layout>

                          <md-layout md-flex="15" class="pl-2 pr-2">
                            <md-radio
                              style="margin: 0 0 0.5rem 0"
                              id="permitted1"
                              name="permitted1"
                              md-value="Original"
                              v-model="item.secondBLRadio"
                              class="md-primary"
                              >Original</md-radio
                            >
                          </md-layout>

                          <md-layout md-flex="15" class="pl-2 pr-2">
                            <md-radio
                              style="margin: 0 0 0.5rem 0"
                              id="permitted2"
                              name="permitted2"
                              v-model="item.secondBLRadio"
                              md-value="seaWayBl"
                              class="md-primary"
                              >Sea Way B/L</md-radio
                            >
                            <span class="error" v-if="!HouseBLModel.secondBLRadio">{{
                              HouseBLModelError.secondBLRadio
                            }}</span>
                          </md-layout>

                          <md-layout md-flex="25" class="pl-2 pr-2">
                            <md-layout md-flex="100">
                              <md-input-container>
                                <label>Upload B/L</label>
                                <md-file
                                  name="secondBLupload"
                                  id="secondBLupload"
                                  v-model="item.secondBLupload"
                                  @selected="
                                    onFileChange('SECOND', item.secondBLupload, index1)
                                  "
                                  multiple
                                ></md-file>
                              </md-input-container>
                            </md-layout>
                          </md-layout>
                        </md-layout>
                        <md-layout md-gutter v-if="item.secondBLupload != ''">
                          <md-layout md-flex="80"></md-layout>
                          <md-layout md-flex="15">
                            <!-- :href="`${docURL}/FF_Sea_Import_Uploads/` + item" -->
                            <!-- :href="`${docURL}/` + item.secondBLupload" -->
                            <a
                              :href="
                                `${docURL}/ASSIGNMENT_UPLOADS/` +
                                JOBSERIES.replaceAll('/', '_') +
                                '/' +
                                item.secondBLupload
                              "
                              target="_blank"
                              download
                              >View Document</a
                            >
                          </md-layout>
                        </md-layout>
                        <md-layout gutter v-if="item.secondBLRadio == 'Original'">
                          <md-layout md-flex="25" class="pl-2 pr-2">
                            <label>Surrender Date</label>
                            <date-picker
                              width="100%"
                              :format="selectDateFormat"
                              lang="en"
                              id="secondBLDate"
                              name="secondBLDate"
                              v-model="item.surrenderDate"
                            ></date-picker>
                          </md-layout>
                          <md-layout md-flex="25" class="pl-2 pr-2">
                            <label>Original BL Received Date</label>
                            <date-picker
                              width="100%"
                              :format="selectDateFormat"
                              lang="en"
                              id="originalBlRecDate"
                              name="originalBlRecDate"
                              v-model="item.originalBlRecDate"
                            ></date-picker>
                          </md-layout>
                        </md-layout>

                        <b-button
                          size="sm"
                          class="ml-2"
                          variant="outline-dark"
                          style="margin-top: 38px"
                          @click="removeHBL(index1)"
                        >
                          <md-icon>remove</md-icon>
                        </b-button>
                      </md-layout>
                    </div>
                  </b-card>
                  <!-- // Added By Priyanshu SIngh Section End -->
                  <md-button
                    v-if="
                      getHouseBLData.length > 0 &&
                      HouseBLModel.houseBLId == ' ' &&
                      ffExoprtDetail.otherNewContainerFLow == 0
                    "
                    @click="showMoreShipper"
                    style="height: 10px; width: 39px"
                    class="md-fab md-fab pull-right"
                  >
                    <md-icon v-if="openShipper == false">add</md-icon>
                    <md-icon v-else>cancel</md-icon>
                  </md-button>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                  <table id="FreghtContaner" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>B/L Number</th>
                        <th>B/L Date</th>
                        <th>Type</th>
                        <th>Ocean Freight Terms</th>
                        <!-- <th v-if="ExecutionDisable==''">Delete</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <!-- {{getHouseBLData}} -->
                      <tr v-for="(item1, index) in getHouseBLData" :key="index">
                        <td class="showMoreData">
                          <span
                            v-if="ffExoprtDetail.otherNewContainerFLow == 0"
                            @click="editHouseBL(item1)"
                          >
                            {{ item1.secondBLNumber }}
                          </span>
                          <span v-else-if="ffExoprtDetail.otherNewContainerFLow == 1">
                            {{ item1.secondBLNumber }}
                          </span>
                        </td>
                        <!-- <td class="showMoreData" v-if="ffExoprtDetail.otherNewContainerFLow==1">
                          {{ item1.secondBLNumber }}
                        </td> -->
                        <!-- {{item1}} -->
                        <td>{{ item1.secondBLDate }}</td>
                        <td>{{ item1.secondBlType }}</td>
                        <td>{{ item1.secondOcFreghtTerms }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.box-body -->
              </div>

              <!-- <hr class="hr-border" v-if="ffExoprtDetail.containerInfo=='lcl'" />
        <md-layout md-gutter class="gutr" v-if="ffExoprtDetail.containerInfo=='lcl'">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Master B/L Number</label>
              <b-form-input :formatter="capitalizeAll"
                id="masterBLNumber"
                name="masterBLNumber"
                v-model="ffExoprtDetail.lclmasterBLNumber"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <label>B/L Date</label>
            <date-picker
              lang="en"
              id="masterBLDate"
              name="masterBLDate"
              v-model="ffExoprtDetail.lclmasterBLDate"
            ></date-picker>
          </md-layout>
              </md-layout>-->
            </div>

            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="ccType">Custom Clearance Type</label>
                <model-list-select
                  :list="cctypeList"
                  v-model="ffExoprtDetail.ccOutSourced"
                  option-value="ccTypeVal"
                  option-text="ccTypeTxt"
                  placeholder="Select CC Type"
                ></model-list-select>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout
                md-flex="50"
                class="pl-2 pr-2"
                v-if="ffExoprtDetail.ccOutSourced == '2'"
              >
                <md-layout md-flex="100">
                  <label>CHA Name</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="ccCha"
                    name="ccCha"
                    v-model="ffExoprtDetail.ccChaName"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- </md-layout>

            <md-layout md-gutter> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="ccType">Transportation Type</label>
                <model-list-select
                  :list="cctypeList"
                  v-model="ffExoprtDetail.tptOutSource"
                  option-value="ccTypeVal"
                  option-text="ccTypeTxt"
                  placeholder="Select TPT Type"
                ></model-list-select>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout
                md-flex="50"
                class="pl-2 pr-2"
                v-if="ffExoprtDetail.tptOutSource == '2'"
              >
                <md-layout md-flex="100">
                  <label>Transporter Name</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="tptChaName"
                    name="tptChaName"
                    v-model="ffExoprtDetail.tptChaName"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- </md-layout>
            <md-layout md-gutter> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="shippingId">Shipping Line Name</label>
                <model-list-select
                  :list="shippingList"
                  v-model="ffExoprtDetail.shippingId"
                  option-value="shippingId"
                  option-text="shippingLine"
                  placeholder="Select Shipping Line"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.shippingId">{{
                  ffExporterrorList.shippingId
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Gateway IGM No.</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="preCarriageBy"
                    name="preCarriageBy"
                    v-model="ffExoprtDetail.gateWayIgmNo"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label>Gateway IGM Date</label>
                <date-picker
                  width="100%"
                  :format="selectDateFormat"
                  lang="en"
                  id="gatewayIgmDate"
                  name="gatewayIgmDate"
                  v-model="ffExoprtDetail.gatewayIgmDate"
                ></date-picker>
              </md-layout>
              <!-- </md-layout>

            <md-layout md-gutter> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Vessel/Voyage</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="vesselVoyage"
                    name="vesselVoyage"
                    v-model="ffExoprtDetail.vesselVoyage"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label>Vessel Arrival Date</label>
                <date-picker
                  width="100%"
                  :format="selectDateFormat"
                  lang="en"
                  id="gatewayIgmDate"
                  name="gatewayIgmDate"
                  v-model="ffExoprtDetail.vesselArrivalDate"
                ></date-picker>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="20">
                  <label for="shipmentType">Source Of Booking</label>

                  <model-list-select
                    :list="shipTypeList"
              v-model="ffExoprtDetail.shipType"
              option-value="shipTypeVal"
              option-text="shipTypeText"
              placeholder="Select Source "
            ></model-list-select>
              </md-layout>-->
            </md-layout>
            <!-- <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30" v-if="ffExoprtDetail.shipType=='Origin'">
            <label for="agentName">Agent Name</label>
            <model-list-select
              :list="agentNameList"
              v-model="ffExoprtDetail.agentName"
              option-value="agntColoaderId"
              option-text="agentName"
              placeholder="Select Agent Name"
            ></model-list-select>
          </md-layout>
        <md-layout md-flex="30" v-if="ffExoprtDetail.shipType=='Destination'">
            <label for="sourceOriginclientId">Client Name</label>
            <model-list-select
              :list="clientList"
              id="clientNamenew"
              v-model="ffExoprtDetail.sourceOriginclientId"
              option-value="clientId"
              option-text="clientName"
              placeholder="Select Client Name"
            ></model-list-select>
          </md-layout>
      <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25" v-if="ffExoprtDetail.shipType=='Destination'">
            <md-layout md-flex="100">
              <label>Buyer Name</label>
              <b-form-input :formatter="capitalizeAll" id="buyer" name="buyer" v-model="ffExoprtDetail.buyer"></b-form-input>
            </md-layout>
          </md-layout>
     
          <md-layout md-flex="25" v-if="ffExoprtDetail.shipType=='Origin'">
            <md-layout md-flex="100">
              <label>Enter Buying House</label>
              <b-form-input :formatter="capitalizeAll"
                id="buyingHouse"
                name="buyingHouse"
                v-model="ffExoprtDetail.buyingHouse"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25" v-if="ffExoprtDetail.shipType=='Origin'">
            <md-layout md-flex="100">
              <label>Other Specify</label>
              <b-form-input :formatter="capitalizeAll"
                id="otherSpecify"
                name="otherSpecify"
                v-model="ffExoprtDetail.otherSpecify"
              ></b-form-input>
            </md-layout>
          </md-layout>
            </md-layout>-->
            <md-layout md-gutter v-if="showLocalIgmDiv == true">
              <md-layout md-flex="25" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Local IGM No.</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="preCarriageBy"
                    name="preCarriageBy"
                    v-model="ffExoprtDetail.localIgmNo"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label>Local IGM Date</label>
                <date-picker
                  width="100%"
                  :format="selectDateFormat"
                  lang="en"
                  id="gatewayIgmDate"
                  name="gatewayIgmDate"
                  v-model="ffExoprtDetail.localIgmDate"
                ></date-picker>
              </md-layout>
            </md-layout>

            <div class="pl-2 pr-2">
              <container-component
                v-if="ALLMODULE"
                :allModuleIdContainer="ALLMODULE"
                JOB="FF"
                TYPE="IMPORT"
              />
            </div>
            <md-layout md-flex="15" class="justify-content-end">
              <b-button
                variant="primary"
                @click="openCommodityModal()"
                id="addButtonLoader"
                size="sm"
                >Add</b-button
              >
            </md-layout>
            <md-layout md-gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="autoCommodity">HSN-Commodity Code *</label>
                <!-- <model-list-select
                  @searchchange="getCommodityList($event, 'getCommodityData')"
                  :list="commodityList"
                  v-model="ffExoprtDetail.commodityId"
                  option-value="commodityId"
                  option-text="itemDescription"
                  placeholder="Select Commodity"
                ></model-list-select> -->

                <model-list-select
                  @searchchange="getCommodityList($event, 'getCommodityData')"
                  :list="commodityList"
                  v-model="ffExoprtDetail.commodityId"
                  option-value="commodityId"
                  option-text="itemHSNCode"
                  placeholder="Select Commodity"
                ></model-list-select>
                <!-- <span class="error" v-if="!ffExoprtDetail.commodityId">{{
                  ffExportCommodityerrorList.commodityId
                }}</span> -->
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->

              <!-- </md-layout>
              <md-layout md-gutter> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <label for="commodityType">Commodity Type</label>
                <model-list-select
                  :list="commodityTypeName"
                  v-model="ffExoprtDetail.commodityType"
                  option-value="commodityTypeVal"
                  option-text="commodityTypeText"
                  placeholder="Select Commodity Type"
                ></model-list-select>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <!-- <md-layout md-flex="40">
                <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>
                <model-list-select
                  :list="deliveryTermsList"
                  v-model="ffExoprtDetail.deliveryTerms"
                  option-value="deliveryTermsVal"
                  option-text="deliveryTermsText"
                  placeholder="Select Delivery Terms"
                ></model-list-select>
              </md-layout> -->
            </md-layout>
            <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Hazardous'">
              <md-layout md-flex="50" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>IMDG Class</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="IMDGClass"
                    name="IMDGClass"
                    v-model="ffExoprtDetail.IMDGClass"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>UN Number</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="UNNumber"
                    name="UNNumber"
                    v-model="ffExoprtDetail.UNNumber"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="25" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Packing Code</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="packingCode"
                    name="packingCode"
                    v-model="ffExoprtDetail.packingCode"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Reefer'">
              <md-layout md-flex="25" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Temperature Req(Degree Celsius)</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="temperatureRequired"
                    name="temperatureRequired"
                    v-model="ffExoprtDetail.temperatureRequired"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter v-if="ffExoprtDetail.commodityType == 'Others'">
              <md-layout md-flex="100" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Specific Detail if any..!</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="otherComodity"
                    name="otherComodity"
                    v-model="ffExoprtDetail.otherComodity"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout gutter>
              <md-layout md-flex="50" class="pl-2 pr-2">
                <!-- <label>Commodity Name, HSN Code and Type</label> -->
                <label>Commodity Remarks</label>
                <b-form-textarea
                  :formatter="capitalizeAll"
                  id="commodity"
                  name="commodity"
                  v-model="ffExoprtDetail.commodity"
                ></b-form-textarea>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout> -->

              <!-- </md-layout>

            <md-layout gutter> -->
              <md-layout md-flex="50" class="pl-2 pr-2">
                <md-layout md-flex="100">
                  <label>Remarks</label>
                  <b-form-textarea
                    :formatter="capitalizeAll"
                    id="remarks"
                    name="remarks"
                    v-model="ffExoprtDetail.remarks"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
              <md-layout md-flex="25" class="pl-2 pr-2">
                <label for="deliveryMode">Destination Delivery Mode</label>
                <model-list-select
                  :list="deliveryModeList"
                  v-model="ffExoprtDetail.deliveryMode"
                  option-value="deliveryModeVal"
                  option-text="deliveryModeText"
                  placeholder="Select Delivery Mode"
                ></model-list-select>
              </md-layout>
            </md-layout>
            <b-row class="justify-content-center mt-2">
              <div>
                <b-button size="sm" @click="showDocModal" variant="dark"
                  >Upload Documents</b-button
                >
              </div>
              <div class="ml-2">
                <b-button
                  variant="primary"
                  id="addButtonLoader"
                  @click="addFFSeaImport('0')"
                  >Save & Submit</b-button
                >
              </div>
              <div class="ml-2" v-if="proceedNext == '1'">
                <b-button
                  variant="primary"
                  id="addButtonLoader"
                  @click="addFFSeaImport('1')"
                  >Save and Proceed to Payment Detail</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>
              </div>
            </b-row>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="note-modal"
      hide-footer
      :title="noteModal.creditDebitNoteType == '1' ? 'CREDIT NOTE' : 'DEBIT NOTE'"
    >
      <div class="d-block text-center">
        <!-- <h3> {{noteModal.creditDebitNoteType=='1'?'CREDIT NOTE':'DEBIT NOTE'}}</h3><br> -->
        <h4 class="error">
          {{
            noteModal.approvalStatus == "1"
              ? "Approved"
              : noteModal.sentForApproval == "1"
              ? "Sent for approval"
              : ""
          }}
        </h4>
      </div>
      <b-button
        v-if="noteModal.uploadCreditDebit != '' && noteModal.approvalStatus == '1'"
        @click="PrintNote(noteModal.uploadCreditDebit)"
        size="sm"
        variant="warning"
        >PDF</b-button
      >
      <b-button @click="addContent" size="sm">
        Add Particulars <i class="fa fa-plus-circle ml-1"></i>
      </b-button>
      <b-row>
        <b-col cols="2">
          <div style="width: 400px">
            <label for="blType">To </label>
            <model-list-select
              :list="AgentColoaderList"
              option-value="agentName"
              option-text="agentName"
              v-model="noteModal.AgentColoader"
              placeholder="Select Agent/Coloader"
            ></model-list-select>
          </div>
          <label>Date</label>
          <date-picker
            :format="selectDateFormat"
            v-model="noteModal.noteDate"
            lang="en"
            id="blDate"
            name="blDate"
          ></date-picker>
        </b-col>
      </b-row>
      <div class="mt-4" v-for="(item, index) in noteParticulars" :key="index">
        <b-row>
          <b-col cols="8">
            <label for="jj">Particular</label>
            <b-form-input
              :formatter="capitalizeAll"
              v-model="item.parti"
              placeholder="Enter Particular"
            ></b-form-input
          ></b-col>
          <b-col cols="2"
            ><label for="jju">Amount</label>
            <b-form-input
              :formatter="capitalizeAll"
              v-model="item.amt"
              type="number"
              placeholder="Enter Amount"
            ></b-form-input>
          </b-col>
          <b-button
            class="pull-right"
            style="margin-top: 38px"
            v-if="index > 0"
            size="sm"
            @click="removeParti(index)"
          >
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
          </b-button>
        </b-row>
      </div>

      <b-row class="mt-2">
        <b-col>
          <label for="jj">Remarks</label>
          <b-form-textarea
            :formatter="capitalizeAll"
            v-model="noteModal.remarks"
          ></b-form-textarea
        ></b-col>
      </b-row>
      <b-button
        class="mt-3"
        variant="success"
        v-if="noteParticulars.length > 0 && ShowSendApproval == true"
        block
        @click="submitNote"
        >Send for approval</b-button
      >
      <b-button class="mt-5" variant="outline-danger" block @click="hideNoteModal"
        >Close</b-button
      >
    </b-modal>
    <div v-if="ALLMODULE">
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        :title="'Assignment Summary & Documents - ' + JOBSERIES"
      >
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>

      <!-- Commodity Modal Added By Priyanshu Singh Start -->
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        size="xl"
        ref="Commodity-modal"
        hide-footer
        title="Add Commodity"
      >
        <!-- <div class="d-block text-center">
        <h3>Add Commodity</h3>
      </div> -->
        <b-row class="justify-content-center">
          <!-- <b-col md="6" class="my-1">
          <b-row> -->
          <b-col md="5">
            <label>Item Name <span class="error">*</span></label>
            <!-- </b-col>
              <b-col md="8" class="my-1"> -->
            <b-form-input
              size="sm"
              :formatter="capitalizeAll"
              id="itemName"
              name="itemName"
              v-model="commodityModal.itemName"
            ></b-form-input>
            <span class="error" v-if="!commodityModal.itemName">{{
              errorList.itemName
            }}</span>
          </b-col>
          <!-- </b-row>
        </b-col> -->
          <b-col md="5">
            <!-- <b-row>
            <b-col md="4" class="text-right"> -->
            <label>HSN Code <span class="error">*</span></label>
            <!-- </b-col>
            <b-col md="8" class="my-1"> -->
            <b-form-input
              size="sm"
              :formatter="capitalizeAll"
              id="hsnCode"
              name="hsnCode"
              v-model="commodityModal.hsnCode"
            ></b-form-input>
            <span class="error" v-if="!commodityModal.hsnCode">{{
              errorList.hsnCode
            }}</span>
          </b-col>
          <!-- </b-row>
        </b-col> -->
          <!-- <b-col md="5" class="my-1"></b-col> -->
          <b-col cols="10" class="my-2 text-center">
            <b-button
              variant="primary"
              @click="addCommodity"
              id="addButtonLoader"
              size="sm"
              >Save</b-button
            >
            <b-button
              variant="outline-danger"
              size="sm"
              class="ml-2"
              @click="hideCommodityModal"
              >Close</b-button
            >
            <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
          </b-col>
          <!-- <b-col md="5" class="my-1"></b-col> -->
        </b-row>
      </b-modal>
      <!-- Commodity Modal Added By Priyanshu Singh Start -->
    </div>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="alertAddSeaImp"
      @close="onCloseAddSeaImp"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
    <md-dialog-alert
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="message"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import ContainerComponent from "../allModuleForm/containerComponent.vue";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity2,
  GlobalContainerValid,
} from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import DocForm from "../../component/allModuleForm/docLibrary.vue";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") ||
      globalPermissionStatus("Overseas Agent Assignments")
    ) {
      this.$store.dispatch("setCurrentRoute", "/seaImport/ffseaImportFcl");
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    ffExoprtDetail: {
      handler: function (newVal, oldVal) {
        if (this.ffExoprtDetail.importerClientId != "") {
          let importerName = this.getCLientData.filter((x) => {
            return x.clientId == this.ffExoprtDetail.importerClientId;
          });

          this.ffExoprtDetail.importerName = importerName[0].clientName;
        }
        // if (this.ffExoprtDetail.exporterClientId != "") {
        //   let exporterName = this.getCLientData.filter(x => {
        //     return x.clientId == this.ffExoprtDetail.exporterClientId;
        //   });

        //   this.ffExoprtDetail.exporterName = exporterName[0].clientName;
        // }
        //   console.log(this.ffExoprtDetail);
        // if (this.ffExoprtDetail.etaFinalDestination != "") {
        //   this.getDayFromDate = new Date(
        //     this.ffExoprtDetail.etaFinalDestination
        //   );

        //   let result = new Date(this.ffExoprtDetail.etaFinalDestination);

        //   let frrD = result + this.ffExoprtDetail.freeDetentionDesti;

        //   // return result;

        //   //         this.ffExoprtDetail.lastFreeDay =
        //   //           this.getDayFromDate +
        //   //           parseInt(this.ffExoprtDetail.freeDetentionDesti);
        //   console.log(
        //     // this.getDayFromDate,
        //     // this.ffExoprtDetail.lastFreeDay,
        //     result,
        //     frrD,
        //     "iuiuou"
        //   );
        // }
        if (this.ffExoprtDetail.containerInfo == "fcl") {
          this.ffExoprtDetail.firstBlType = "MasterBL";
        } else {
          this.ffExoprtDetail.firstBlType = "Co-Loader";
        }

        // if (this.ffExoprtDetail.PORlocationId != "") {
        //   let array = this.IcdPOrtList.filter(x => {
        //     return x.pickupId == newVal.PORlocationId;
        //   })[0];

        //   this.ffExoprtDetail.portType = array.locationType;
        //   if (array.locationType != "Icd") {
        //     this.PortLoadList = this.IcdPOrtList;
        //     this.ffExoprtDetail.LPlocationId = newVal.PORlocationId;
        //   }

        //   this.deliveryTermsList[1].deliveryTermsText =
        //     "FOB_POR_ " + array.mainLocation;
        // }
        // if (this.ffExoprtDetail.LPlocationId != "") {
        //   let array = this.PortLoadList.filter(x => {
        //     return x.pickupId == this.ffExoprtDetail.LPlocationId;
        //   })[0];
        //   this.deliveryTermsList[2].deliveryTermsText =
        //     "FOB_LP_ " + array.mainLocation;
        // }

        // if (this.ffExoprtDetail.finalPlaceLocationId != "") {
        //   let arrayFPODTYPE = this.finalAllPlaceData.filter(x => {
        //     return x.pickupId == this.ffExoprtDetail.finalPlaceLocationId;
        //   });
        //   if (arrayFPODTYPE.length > 0) {
        //     if (
        //       arrayFPODTYPE[0].locationType == "Sea_Port" ||
        //       arrayFPODTYPE[0].locationType == "Air_Port"
        //     ) {
        //       this.$sessionsStorage.set("FPODTYPE", "PORT");
        //     } else {
        //       this.$sessionsStorage.set("FPODTYPE", "ICD");
        //     }
        //   }
        // }
        // if (this.ffExoprtDetail.PORlocationId != "") {
        //   let arrayPORTYPE = this.IcdPOrtListNew.filter(x => {
        //     return x.pickupId == this.ffExoprtDetail.PORlocationId;
        //   });
        //   if (arrayPORTYPE.length > 0) {
        //     if (arrayPORTYPE[0].locationType == "Sea_Port") {
        //       this.$sessionsStorage.set("PORTYPE", "SEA");
        //     } else {
        //       this.$sessionsStorage.set("PORTYPE", "ICD");
        //     }
        //   }
        // }

        if (this.ffExoprtDetail.importerClientId != "") {
          let arrayImp = this.getCLientData.filter((x) => {
            return x.clientId == this.ffExoprtDetail.importerClientId;
          });

          if (arrayImp.length > 0) {
            this.bookingPartyList[0].billingPartyTxt =
              "Importer_" + arrayImp[0].clientName;
            this.showAdditionalMoreTaskArray[0].show =
              "Importer_" + arrayImp[0].clientName;
          }
        }
        // if (this.ffExoprtDetail.exporterClientId != "") {
        //   this.bookingPartyList[1].billingPartyTxt =
        //     "Exporter_" + this.ffExoprtDetail.exporterName;
        //   this.showAdditionalMoreTaskArray[1].show =
        //     "Exporter_" + this.ffExoprtDetail.exporterName;
        // }
        if (this.ffExoprtDetail.agentName != "") {
          let Agnt = this.getagentName.filter((x) => {
            return x.agntColoaderId == this.ffExoprtDetail.agentName;
          });

          this.bookingPartyList[2].billingPartyTxt = "Agent_" + Agnt[0].agentName;
          this.showAdditionalMoreTaskArray[2].show = "Agent_" + Agnt[0].agentName;
        }
      },

      deep: true,
    },
  },
  data() {
    return {
      // CUstom Validation Variable Declaration Start 23/06/2023
      errorCustomValidation: {
        sailDate: "",
        alertReceivedDate: "",
        igmManifestationDate: "",
        vesselEtaDate: "",
        firstBLNumber: "",
        firstBlType: "",
        firstBLDate: "",
      },
      ffExoprtDetail:{
        sailDate: "",
        alertReceivedDate: "",
        igmManifestationDate: "",
        vesselEtaDate: "",
        firstBLNumber: "",
        firstBlType: "",
        firstBLDate: "",
      },

      arrayErrorCustomValidation: [
        {
          sailDate: "Enter SOB Date ",
          alertReceivedDate: "Enter Pre-Alert Received Date",
          igmManifestationDate: "Enter IGM Manifestation Date",
          vesselEtaDate: "Enter Vessel ETA Date ",
          firstBLNumber: "Enter B/L Number",
          firstBlType: "Enter B/L Type",
          firstBLDate: "Enter B/L Date",
        },
      ],
      // CUstom Validation Variable Declaration End 23/06/2023
      // Added vy Priyanshu Singh Start
      ffExportCommodityError: ["Please Select Commidity"],
      ffExportCommodityerrorList: {
        commodityId: "",
      },
      commodityModal: {
        commodityNewId: "",
        itemName: "",
        hsnCode: "",
      },
      CommodityError: [
        "Please Enter ItemName",
        // "Please Enter HSNCode",
      ],
      errorList: {
        itemName: "",
        // hsnCode: "",
      },
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "DANGEROUS CARGO (HAZ)",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL (OTHERS)",
        },
      ],
      deliveryTermsName: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "EXWORKS",
        },
        {
          deliveryTermsVal: "FOB",
          deliveryTermsText: "FOB",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDU",
          deliveryTermsText: "DDU",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
      ],
      // Added vy Priyanshu Singh End
      selectDateFormat,
      assignmentNo: "",
      pickupLocation: "",
      vesselVoyage: "",
      user_baselocation: "",
      containerNo: "",
      AgentColoaderList: [],
      noteParticulars: [],
      ShowSendApproval: "",
      allModuleId: "",
      note_id: "",
      noteModal: {
        branchName: "",
        branchList: [],
        AgentColoader: "",
        creditDebitNoteType: "",
        remarks: "",
        noteDate: "",
        note_id: "",
        noteContent: "",
        noteAmount: "",
        ffExportFclId: "",
        allModuleId: "",
        fclBlId: "",
        BLNumber: "",
        uploadCreditDebit: "",
        sentForApproval: "",
        approvalStatus: "",
        masterorLinerBlNo: "",
      },
      CLIENTNAME: "",
      prbr_id:"",
      ALLMODULE: "",
      JOBSERIES: "",
      allSame: "0",
      docURL: URL_BASE_DOC,
      showLocalIgmDiv: false,
      errorContainerType: {
        noOfContainer: "",
        containerTypeId: "",
      },
      errorContainerTypeArray: {
        noOfContainer: "Enter no of Container",
        containerTypeId: "Select Container Type",
      },
      stuffingTypeName: [
        {
          stuffingTypeVal: "factoryStuffing",
          stuffingTypeText: "Factory",
        },
        {
          stuffingTypeVal: "warehouseStuffing",
          stuffingTypeText: "Warehouse",
        },
      ],
      firstRadio: "",

      ContainerTypeModel: {
        containerTypeId: "",
        noOfContainer: "",
        ffContainerTypeId: "",
      },
      bookingPartyList: [
        {
          billingPartyVal: "Importer",
          billingPartyTxt: "Importer",
        },
        {
          billingPartyVal: "Exporter",
          billingPartyTxt: "Exporter",
        },
        {
          billingPartyVal: "Agent",
          billingPartyTxt: "Agent",
        },

        {
          billingPartyVal: "Other",
          billingPartyTxt: "Other",
        },
      ],
      editorOption: {
        modules: {},
      },
      tempHouse: "",
      containerTypeDetailFactory: [],
      ContainerTypeSizefactory: {
        ffContainerId: "",
        containerTypeId: "",
        contfreeDays: "",

        containerNo: "",

        measurement: "",
        lineSealNo: "",
        noOfPkg: "",
        packageId: "",
        podETA: "",
        validUpto: "",
        cfsETA: "",
        icdETA: "",
        ffImportId: "",
      },
      showAdditionalMoreTaskArray: [
        {
          value: "Importer",
          show: "Importer",
        },
        {
          value: "Exporter",
          show: "Exporter",
        },

        {
          value: "Agent",
          show: "Agent",
        },

        {
          value: "Other",
          show: "Other",
        },
      ],
      jitu: ["1", "2", "3"],
      ajit: ["1", "3"],
      errorContainer: {
        containerTypeId: "",

        containerNo: "",

        measurement: "",
        lineSealNo: "",
        noOfPkg: "",
        packageId: "",
      },
      arrayContainerError: [
        "Select Container Type",
        "Enter Container No.",
        "Enter Container Gross Weight",
        "Enter measurement",
        "Enter line seal no",
        "Enter no of package",
        "Enter package name",
      ],
      editorContent: "",
      isLoading: false,
      transportTypeList: [
        {
          transportTypeVal: "SeaExport",
          transportTypeText: "Sea Export",
        },
        {
          transportTypeVal: "SeaImport",
          transportTypeText: "Sea",
        },
      ],
      blTypeList: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L",
        },

        {
          blTypeVal: "MasterBL",
          blTypeTxt: "Master B/L",
        },
      ],
      blTypeListLcl: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L",
        },

        {
          blTypeVal: "Co-Loader",
          blTypeTxt: "Co-Loader",
        },
      ],

      cctypeList: [
        {
          ccTypeVal: "1",
          ccTypeTxt: "Pridel",
        },
        {
          ccTypeVal: "2",
          ccTypeTxt: "Outsourced",
        },
        {
          ccTypeVal: "3",
          ccTypeTxt: "Not Applicable",
        },
      ],

      containerInfoList: [
        {
          containerInfoVal: "fcl",
          containerInfoText: "FCL",
        },
        {
          containerInfoVal: "lcl",
          containerInfoText: "LCL",
        },
      ],

      destiHandleList: [
        {
          DHVal: "1",
          DHText: "Pridel",
        },
        {
          DHVal: "2",
          DHText: "Consignee",
        },
      ],
      deliveryModeList: [
        {
          deliveryModeVal: "CY_CY",
          deliveryModeText: "CY / CY",
        },
        {
          deliveryModeVal: "CY_RAMP",
          deliveryModeText: "CY / RAMP",
        },
        {
          deliveryModeVal: "CY_StoreDoor",
          deliveryModeText: "CY / Store Door",
        },
      ],
      deliveryTermsList: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "EXWORKS",
        },
        {
          deliveryTermsVal: "FOB",
          deliveryTermsText: "FOB",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDU",
          deliveryTermsText: "DDU",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
      ],
      deliveryTermsList_bak: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "Ex-Works",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "FOB_POR",
          deliveryTermsText: "FOB_POR_",
        },
        {
          deliveryTermsVal: "FOB_LoadPort",
          deliveryTermsText: "FOB_LoadPort_",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
        {
          deliveryTermsVal: "FAS",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "CIP",
          deliveryTermsText: "CIP",
        },
        {
          deliveryTermsVal: "CPT",
          deliveryTermsText: "CPT",
        },
        {
          deliveryTermsVal: "DAF",
          deliveryTermsText: "DAF",
        },
        {
          deliveryTermsVal: "DES",
          deliveryTermsText: "DES",
        },
        {
          deliveryTermsVal: "DEQ",
          deliveryTermsText: "DEQ",
        },
      ],

      oceanFreightTermsList: [
        {
          oceanFreightTermsVal: "prepaid",
          oceanFreightTermsText: "Prepaid",
        },
        {
          oceanFreightTermsVal: "collect",
          oceanFreightTermsText: "Collect",
        },
      ],

      showAdd: false,
      getHouseBLData: [],

      shipTypeList: [
        {
          shipTypeVal: "Origin",
          shipTypeText: "Origin",
        },
        {
          shipTypeVal: "Destination",
          shipTypeText: "Destination",
        },
      ],

      agentListName: [
        {
          agentNameVal: "agentName1",
          agentNameText: "agentName1",
        },
        {
          agentNameVal: "agentName2",
          agentNameText: "agentName2",
        },
      ],

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      allAgentColoader: [],
      getagentName: [],
      ccContainers: "",
      CommodityAll: {},
      autoClientName: {},
      notifyArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "FiFth",
        "Sixth",
        "Seventh",
        "Eight",
        "Ninth",
        "Tenth",
      ],
      notifyListArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "Fifth",
        "Sixth",
        "Seven",
        "Eight",
      ],
      ffExoprtDetail: {
        // Added By Priyansu Singh Start
        commodityId: "",
        commodityType: "",
        IMDGClass: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        // Added By Priyansu Singh End
        allModuleId: "",
        stuffingType: "",
        vesselEtaDate: "",
        multiContainer: [],
        hbl_Arr: [],
        sameConNo: false,
        noOfContainers: "",
        statusFinal: "",
        surrenderDate: "",
        originalBlRecDate: "",
        bookingParty: "",
        billingParty: "",
        portType: "",
        ffImportId: "",

        transportType: "SeaImport",
        grossWeight: "",
        containerInfo: "fcl",
        shippingId: "",
        sailDate: "",
        alertReceivedDate: "",
        importerClientId: "",
        importerName: "",
        exporterClientId: "",
        exporterName: "",
        coLoaderName: "",
        firstBLNumber: "",
        firstBLDate: "",
        firstBlType: "",
        firstBLRadio: "",
        firstOcFreghtTerms: "",
        firstBLupload: "",
        inputValue: "",
        notifyList: [
          {
            inputValue: "",
            text: "",
          },
          {
            inputValue: "",
            text: "Second",
          },
        ],
        lclmasterBLNumber: "",
        lclmasterBLDate: "",

        ccOutSourced: "",
        ccChaName: "",
        tptOutSource: "",
        tptChaName: "",
        freeDetentionDesti: "",
        etaDischargePort: "",
        etaFinalDestination: "",
        lastFreeDay: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        preCarriageBy: "",
        vesselVoyage: "",
        shipType: "",
        agentName: "",
        sourceOriginclientId: "",
        buyer: "",
        buyingHouse: "",
        otherSpecify: "",
        marksNos: "",
        containerSealNo: "",
        noOfContainer: "",
        goodsDescription: "",
        commodity: "",
        Measurement: "",
        deliveryMode: "",
        deliveryTerms: "",
        remarks: "",
        freeDaysIndiaPort: "",
        destinationHandling: "",
        igmManifestationDate: "",
        gateWayIgmNo: "",
        gatewayIgmDate: "",
        vesselArrivalDate: "",
        localIgmNo: "",
        localIgmDate: "",
      },
      arrivalDateIndex: "",
      railOutDateIndex: "",
      freeDaysIndex: "",
      getContainerList: [],
      getContainerTypeList: [],
      getContainerTypeFinal: [],

      HouseBLModel: {
        surrenderDate: "",
        originalBlRecDate: "",
        secondBLNumber: "",
        secondBLDate: "",
        secondBlType: "HouseBL",
        secondBLRadio: "",
        secondOcFreghtTerms: "",
        secondBLupload: "",
        houseBLId: "",
        inputValue: "",
        notifyList: [
          {
            inputValue: "",
            text: "",
          },
          {
            inputValue: "",
            text: "Second",
          },
        ],
      },

      HouseBLModelError: {
        secondBLNumber: "",
        secondBLDate: "",
        secondBlType: "",
        secondBLRadio: "",
      },
      multiContainer: [],
      containerNo: [],

      HouseBLModelErrorList: [
        "Enter Second B/L Number",
        "Select Second B/L Date",
        "Select Second B/L Type",
        "Select Second B/L Radio",
      ],
      getDayFromDate: "",

      deleteId: "",
      packageMaster: [],

      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",

      fobReceiptName: "",
      fobLoadPortName: "",
      commodityArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },
      getCLientData: ["gfdg"],
      showSegmentArray: [],
      openContainer: false,
      openContainerType: false,
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },
      showAlgo: false,
      algoConNo: "",
      errorAtleastOne: "",
      ffExportError: [
        "Select Shipping Line",
        "Select SOB Date",
        "Select Pre-Alert Date",
        "Select Importer Name",
        "Select Exporter Name",

        "Select Place of Recipt",
        "Select Load Port",
        "Select Port Of Discharge",
        "Select Final Place Delivery",
        "Enter First B/L Number",
        "Select First B/L Date",
        "Select First B/L Type",
        "Enter Second B/L Number",
        "Select Second B/L Date",
        "Select Second B/L Type",
        "Select Second B/L Type",
      ],
      ffExporterrorList: {
        shippingId: "",
        sailDate: "",
        alertReceivedDate: "",
        importerClientId: "",
        exporterClientId: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        firstBLNumber: "",
        firstBLDate: "",
        firstBLRadio: "",
      },
      ffExportErrorLCL: ["Select Coloader Name"],
      ffExporterrorListLCL: {
        coLoaderName: "",
      },

      shipmentTypeName: [
        {
          shipmentTypeVal: "Sea_Shipment",
          shipmentTypeText: "Sea Shipment",
        },
        {
          shipmentTypeVal: "Air_Shipment",
          shipmentTypeText: "Air_Shipment",
        },
      ],

      otherServicesVal: false,
      containerNoRegexError: [],

      getShippingLineData: ["zim"],
      getCommodityData: ["zim"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: ["agra"],
      IcdPOrtList: [],
      PortLoadList: [],
      getPortDischargeList: [],
      finalAllPlaceData: [],
      validate: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      ExecutionDisable: "",
      FPODTYPE: this.$sessionsStorage.get("FPODTYPE"),
      PORTYPE: this.$sessionsStorage.get("PORTYPE"),

      openShipper: false,
      validateContainerType: false,
      validateContainerTypeFinal: false,
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    DocForm,
    ContainerComponent,
    BannerComponent,
  },
  computed: {
    proceedNext() {
      return this.$store.getters.storeProceedContainer;
    },
    containerTypeDetailFactoryList() {
      return this.containerTypeDetailFactory;
    },
    clientList() {
      return this.getCLientData;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    firstBlUploadView() {
      return this.ffExoprtDetail.firstBLupload != ""
        ? this.ffExoprtDetail.firstBLupload.split(",")
        : [];
    },
    secondBlUploadView() {
      if (this.HouseBLModel.secondBLupload != null) {
        return this.HouseBLModel.secondBLupload != ""
          ? this.HouseBLModel.secondBLupload.split(",")
          : [];
      } else {
        return this.HouseBLModel.secondBLupload == 0;
      }
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.getCommodityData;
    },
    deliveryTermsList() {
      return this.deliveryTermsName;
    },
    prepaidDetailsList() {
      return this.prepaidDetailsName;
    },
    collectDetailsList() {
      return this.collectDetailsName;
    },

    agentNameList() {
      return this.getagentName;
    },
    getColoaderNameList() {
      return this.getColoaderName;
    },
  },
  methods: {
    // Added By Priyanshu Singh Start
    addNotifyHBL(index) {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.getHouseBLData.notifyList.length],
      };
      this.getHouseBLData[index].notifyList.push(obj);
    },
    removeNotifyHBL(index) {
      this.getHouseBLData[index].notifyList.splice(index, 1);
    },
    addAdditionalHBL() {
      let doSection1 = {
        surrenderDate: "",
        originalBlRecDate: "",
        secondBLNumber: "",
        secondBLDate: "",
        secondBlType: "HouseBL",
        secondBLRadio: "",
        secondOcFreghtTerms: "",
        secondBLupload: "",
        houseBLId: "",
        inputValue: "",
        notifyList: [
          {
            inputValue: "",
            text: "",
          },
        ],
      };
      this.getHouseBLData.push(doSection1);
    },
    removeHBL(index) {
      this.getHouseBLData.splice(index, 1);
    },
    sendMANIFESTATION() {
      this.$sessionsStorage.set("sendManifest_ffIMPFclallModuleId", "");
      this.$sessionsStorage.set("sendManifest_ffType", "");
      this.$forceUpdate();
      this.$sessionsStorage.set("sendManifest_ffIMPFclallModuleId", this.allModuleId);
      this.$sessionsStorage.set("sendManifest_ffType", "FF Import");
      this.$sessionsStorage.set(
        "sendManifest_ffIMPFclId",
        this.$sessionsStorage.get("editffSeaImportId")
      );
      this.$router.push({
        path: "/seaImport/sendManifestation",
      });
    },
    // Added By Priyanshu Singh End
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    PrintNote(item) {
      let key =
        "ASSIGNMENT_UPLOADS/" +
        this.assignmentNo.replaceAll("/", "_") +
        "/" +
        item;
      this.openSignedDocument(key);
    },
    removeParti(index) {
      this.noteParticulars.splice(index, 1);
    },
    getCommodityList(event, vmodelArray) {
      let vehicle_drive = {
        value: event,
      };

      let self = this;

      if (event != "") {
        GlobalGetCommodity2(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              // console.log(self[vmodelArray]);
            }
          }
        });
      }
    },
    openNoteModal(id) {
      this.isLoading = true;
      this.getNoteData(id);
      setTimeout(() => {
        this.noteModal.creditDebitNoteType = id;
        if (this.noteContent) {
          let dummyCont = this.noteContent.split(",");
          let dummyAmt = this.noteAmount.split(",");

          for (let i = 0; i < dummyCont.length; i++) {
            let obj = {
              parti: dummyCont[i],
              amt: dummyAmt[i],
            };

            this.noteParticulars.push(obj);
          }
        }
        // if(arrayNote[0].sentForApproval=='0'){
        // this.ShowSendApproval=true
        // }else{
        // this.ShowSendApproval=false
        // }
        // }else{
        // this.ShowSendApproval=true
        // }
        // // this.noteModal.note_id=this.creditDebitNoteData[0].note_id
        // // this.noteModal.creditDebitNoteType=this.creditDebitNoteData[0].creditDebitNoteType
        // // this.noteModal.note=this.creditDebitNoteData[0].note_id
        // }else{
        // this.ShowSendApproval=true
        // }
        this.isLoading = false;
        this.ShowSendApproval = true;
        this.$refs["note-modal"].show();
        this.getData();
      }, 2000);
    },
    hideNoteModal() {
      Object.keys(this.noteModal).map((x, index) => {
        this.noteModal[x] = "";
      });
      this.noteModal.approvalStatus = "";
      this.noteModal.sentForApproval = "";
      this.noteContent = "";
      this.noteAmount = "";
      this.note_id = "";
      this.noteModal.remarks = "";
      this.noteParticulars = [];
      this.$refs["note-modal"].hide();
      this.isLoading = false;
    },
    addContent() {
      let obj = {
        parti: "",
        amt: "",
      };

      this.noteParticulars.push(obj);
      // console.log(this.noteParticulars);
    },

    onFileChange(ID, secondBLupload, index1) {
      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        if (ID == "FIRST") {
          formData.append(
            "moduleId",
            this.$sessionsStorage.get("editffSeaImportId")
            // +
            //   "-" +
            //   this.sbDetailArrayList.length +
            //   "-" +
            //   this.SBDetail.shippingSBId
          );
        } else {
          "moduleId",
            this.$sessionsStorage.get("editffSeaImportId") +
              "-" +
              this.getHouseBLData.length +
              "-" +
              this.HouseBLModel.houseBLId;
        }

        if (ID == "FIRST") {
          formData.append("staticFileName", "Sea_Import_FirstBL");
        } else if (ID == "SECOND") {
          formData.append("staticFileName", this.JOBSERIES.replaceAll("/", "_"));
          // formData.append("staticFileName", "Sea_Import_SecondBL");
        } else {
          console.log("error");
        }

        formData.append("upload_dir_folderName", this.JOBSERIES.replaceAll("/", "_"));

        // formData.append("upload_dir_folderName", "FF_Sea_Import_Uploads");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios

        // .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          if (ID == "FIRST") {
            this.ffExoprtDetail.firstBLupload = result.data;
          } else if (ID == "SECOND") {
            this.HouseBLModel.secondBLupload = result.data;
            this.getHouseBLData[index1].secondBLupload = result.data;
          } else {
            console.log("error");
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    addSameDate(index) {
      this.arrivalDateIndex = this.multiContainer[index].arrivalDate;

      this.railOutDateIndex = this.multiContainer[index].railOutDate;
      this.freeDaysIndex = this.multiContainer[index].freeDays;
    },

    // addSameDateRadio() {
    //   if (this.firstRadio == "1") {
    //     this.multiContainer.map(x => {
    //       x.arrivalDate = this.arrivalDateIndex;
    //       x.railOutDate = this.railOutDateIndex;
    //       x.freeDays = this.freeDaysIndex;
    //     });
    //   }
    // },

    addSameDateRadio() {
      if (this.allSame == "1") {
        this.multiContainer.map((x) => {
          x.arrivalDate = "";
          x.railOutDate = "";
          x.freeDays = "";
        });
      } else {
        // console.log("56565");
        this.multiContainer.map((x) => {
          x.arrivalDate = this.arrivalDateIndex;
          x.railOutDate = this.railOutDateIndex;
          x.freeDays = this.freeDaysIndex;
        });
      }
    },
    // getNoofCon() {
    //   if (
    //     this.ffExoprtDetail.noOfContainers != ""
    //     //&& this.ffExoprtDetail.ffImportId == ""
    //   ) {
    //     let array = [];
    //     for (let i = 0; i < this.ffExoprtDetail.noOfContainers; i++) {
    //       let obj = {
    //         ContainerNo: "",
    //         ContainerType: "",
    //         railOutDate: "",
    //         arrivalDate: "",
    //         freeDays: ""
    //       };

    //       // let obj1 = {
    //       //   ContainerNo1: "",
    //       //   ContainerType1: "",
    //       //   railOutDate1: "",
    //       //   arrivalDate1: "",
    //       //   freeDays1: ""
    //       // };

    //       array.push(obj);
    //       //  this.errorMultiContainer.push(obj1);
    //     }
    //     return (this.multiContainer = array);
    //   } else if (
    //     this.ffExoprtDetail.noOfContainers == "" ||
    //     this.ffExoprtDetail.noOfContainers == 0 ||
    //     this.ffExoprtDetail.noOfContainers == "0"
    //   ) {
    //     this.multiContainer = [];
    //   }
    // },
    addStatus() {
      let data = {
        jobType: "1",
        typeOf: "5",
        allMessageId: this.$sessionsStorage.get("editffSeaImportId"),
        statusMain: this.ffExoprtDetail.statusFinal,
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/internalAssignStatus",
      });
    },
    DeleteList(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_sea_import_multicontainer_type",
          tableId: "ffContainerTypeId",
          isActive: "isActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            this.getData();
            this.getContainerList = [];
          })
          .catch((error) => {});
      }
    },
    // getFreeDate() {
    //   if (this.$sessionsStorage.get("FPODTYPE") == "ICD") {
    //     let newdate = new Date(this.ffExoprtDetail.etaFinalDestination);

    //     newdate.setDate(
    //       newdate.getDate() +
    //         parseInt(this.ffExoprtDetail.freeDetentionDesti) -
    //         parseInt(1)
    //     );

    //     this.ffExoprtDetail.lastFreeDay = newdate;
    //   } else {
    //     let newdatePort = new Date(this.ffExoprtDetail.etaDischargePort);

    //     newdatePort.setDate(
    //       newdatePort.getDate() +
    //         parseInt(this.ffExoprtDetail.freeDetentionDesti) -
    //         parseInt(1)
    //     );

    //     this.ffExoprtDetail.lastFreeDay = newdatePort;
    //   }
    // },
    containerNoRegexfun(index) {
      let abc = this.multiContainer[index].ContainerNo.toUpperCase();

      this.multiContainer[index].ContainerNo = abc;
      // console.log(this.multiContainer[index].ContainerNo);
      this.showAlgo = true;
      this.getConAlgoList(index);
      this.algoConNo = this.validContainerNo;
      // console.log(this.validContainerNo);
      var containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");

      if (containerformat.test(this.multiContainer[index].ContainerNo)) {
        this.containerNoRegexError[index] = "";
        if (this.multiContainer[index].ContainerNo != this.algoConNo) {
          this.containerNoRegexError[index] =
            "Note:System Generated Container No. is : " + this.algoConNo;
        } else {
          this.containerNoRegexError[index] = "";
        }
      } else {
        this.containerNoRegexError[index] = "Enter Valid Format";
      }
      this.$forceUpdate();
    },
    getConAlgoList(index) {
      //let self = this;

      if (this.multiContainer[index].ContainerNo != "") {
        this.validContainerNo = GlobalContainerValid(
          this.multiContainer[index].ContainerNo
        );
      }
    },
    showMoreShipper() {
      this.HouseBLModel.secondBlType = this.tempHouse;
      this.HouseBLModel.notifyList = [];
      let obj = {
        inputValue: "",
        text: "",
      };
      this.HouseBLModel.notifyList.push(obj);
      if (this.openShipper == false) {
        this.openShipper = true;
      } else {
        this.openShipper = false;
      }
    },
    showMoreContainer() {
      if (this.openContainer == false) {
        this.openContainer = true;
      } else {
        this.openContainer = false;
      }
    },
    showMoreContainerType() {
      if (this.openContainerType == false) {
        this.openContainerType = true;
      } else {
        this.openContainerType = false;
      }
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    onFileChangeFirstBl() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId"),
        },
      };

      axios
        .post(`${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`, formData, config)
        .then((result) => {
          this.ffExoprtDetail.firstBLupload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    onFileChangeSecBl() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId"),
        },
      };

      axios
        .post(`${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`, formData, config)
        .then((result) => {
          this.HouseBLModel.secondBLupload = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    onCloseAddSeaImp() {
      this.$router.push({
        path: "/seaImport/ffSeaImportExecution",
      });
    },

    addNotify() {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.HouseBLModel.notifyList.length],
      };
      this.HouseBLModel.notifyList.push(obj);
    },
    removeNotify(index) {
      this.HouseBLModel.notifyList.splice(index, 1);
    },
    addNotifyMaster() {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.ffExoprtDetail.notifyList.length],
      };
      this.ffExoprtDetail.notifyList.push(obj);
    },
    removeNotifyMaster(index) {
      this.ffExoprtDetail.notifyList.splice(index, 1);
    },

    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    editHouseBL(item) {
      let arrayEdit = [];
      arrayEdit.push(item);

      this.HouseBLModel.secondBLNumber = arrayEdit[0].secondBLNumber;
      this.HouseBLModel.houseBLId = arrayEdit[0].houseBLId;
      this.HouseBLModel.secondBLDate = arrayEdit[0].secondBLDate;
      this.HouseBLModel.secondBlType = arrayEdit[0].secondBlType;
      this.tempHouse = this.HouseBLModel.secondBlType;

      this.HouseBLModel.secondBLRadio = arrayEdit[0].secondBLRadio;

      this.HouseBLModel.secondOcFreghtTerms = arrayEdit[0].secondOcFreghtTerms;

      this.HouseBLModel.secondBLupload = arrayEdit[0].secondBLupload;
      this.HouseBLModel.surrenderDate = arrayEdit[0].surrenderDate;
      this.HouseBLModel.originalBlRecDate = arrayEdit[0].originalBlRecDate;
      // console.log("Priyanshu SIngh=>", this.HouseBLModel);

      if (arrayEdit[0].notifyList != "" && this.HouseBLModel.houseBLId != "") {
        this.HouseBLModel.notifyList = [];
        arrayEdit[0].notifyList.split("$$$").map((y, index) => {
          let obj = {
            inputValue: y,
            text: this.notifyListArray[index],
          };

          this.HouseBLModel.notifyList.push(obj);
        });
      } else {
        this.HouseBLModel.notifyList = [];
        let obj = {
          inputValue: "",
          text: "",
        };
        this.HouseBLModel.notifyList.push(obj);
      }
      // console.log("Priyanshu SIngh=>", this.HouseBLModel);
    },
    editContainer(item) {
      Object.keys(this.ContainerTypeSizefactory).map((x) => {
        this.ContainerTypeSizefactory[x] = item[x];
      });
    },
    validateFFExport(id) {
      let validate_new = true;

      if (id == "3") {
        Object.keys(this.HouseBLModelError).map((x, index) => {
          if (this.HouseBLModel[x] == "") {
            this.HouseBLModelError[x] = this.HouseBLModelErrorList[index];
            validate_new = false;
          } else {
            this.HouseBLModelError[x] = "";
          }
        });
      }

      if (id == "5") {
        if (
          this.getContainerTypeList.length > 0 &&
          this.ContainerTypeModel.ffContainerTypeId == ""
        ) {
          let array = this.getContainerTypeList.filter((x) => {
            return x.containerTypeId == this.ContainerTypeModel.containerTypeId;
          });
          if (array.length > 0) {
            this.alert.content = array[0].containerType + " Already Exist";
            this.ContainerTypeModel.containerTypeId = "";

            this.$refs["addPop"].open();
            validate_new = false;
          }
        }
        Object.keys(this.errorContainerType).map((x, index) => {
          if (this.ContainerTypeModel[x] == "") {
            this.errorContainerType[x] = this.errorContainerTypeArray[x];
            validate_new = false;
          } else {
            this.errorContainerType[x] = "";
          }
        });
      }

      if (id == "2") {
        Object.keys(this.errorContainer).map((x, index) => {
          if (this.ContainerTypeSizefactory[x] == "") {
            this.errorContainer[x] = this.arrayContainerError[index];
            validate_new = false;
          } else {
            this.errorContainer[x] = "";
          }
        });
      }

      if (this.ffExoprtDetail.containerInfo == "fcl") {
        Object.keys(this.ffExporterrorList).map((x, index) => {
          if (this.ffExoprtDetail[x] == "") {
            this.ffExporterrorList[x] = this.ffExportError[index];
            validate_new = false;
          }
        });
      } else {
        Object.keys(this.ffExporterrorList).map((x, index) => {
          if (this.ffExoprtDetail[x] == "") {
            this.ffExporterrorList[x] = this.ffExportError[index];
            validate_new = false;
          }
        });

        Object.keys(this.ffExporterrorListLCL).map((x, index) => {
          if (this.ffExoprtDetail[x] == "") {
            this.ffExporterrorListLCL[x] = this.ffExportErrorLCL[index];
            validate_new = false;
          }
        });
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    // CUstom Validation Variable Declaration Start 23/06/2023
    validateFFImportCustomVali() {
      let validate_new = true;
      Object.keys(this.errorCustomValidation).map((x, index) => {
        if (
          this.ffExoprtDetail[x] == "" ||
          this.ffExoprtDetail[x] == 0 ||
          this.ffExoprtDetail[x] == undefined ||
          this.ffExoprtDetail[x] == null ||
          this.ffExoprtDetail[x] == "undefined" ||
          this.ffExoprtDetail[x] == "null"
        ) {

            console.log("this.errorCustomValidation[x] this.ffExoprtDetail[x]=>", this.ffExoprtDetail[x]);
            console.log("this.errorCustomValidation[x] x=>", x);
            console.log("this.errorCustomValidation[x]=>", this.errorCustomValidation[x]);
            console.log("this.arrayErrorCustomValidation[0][x]=>",this.arrayErrorCustomValidation[0][x]);
            this.errorCustomValidation[x] = this.arrayErrorCustomValidation[0][x];

            validate_new = false;

            // validate_new = false;
          
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    // CUstom Validation Variable Declaration End 23/06/2023
    addFFSeaImport(id) {
      this.ffExoprtDetail["multiContainer"] = this.multiContainer;
      // this.validateFFExport(id);
      if (this.ffExoprtDetail.commodityId == "" || this.ffExoprtDetail.commodityId == 0) {
        this.ffExportCommodityerrorList.commodityId = "Please Select Commidity";
        this.alert.content = "Please Select Commidity";
        this.$refs["addPop"].open();
        // this.validate =false;
        return false;
      }
      // console.log("Priyanshu SIngh=>",this.getHouseBLData)
      this.ffExoprtDetail.hbl_Arr = [];
      if (this.getHouseBLData.length > 0) {
        this.getHouseBLData.forEach((element) => {
          element.multiHBLNo = element.secondBLNumber;
          element.BlType = element.secondBLRadio;
          element.BlType = element.secondBlType;
          element.multiHBLDate = element.secondBLDate;
          element.notifyList = element.notifyList;
          element.surrenderDate = element.surrenderDate;
          element.originalBlRecDate = element.originalBlRecDate;
          element.secondBLRadio = element.secondBLRadio;
          element.secondOcFreghtTerms = element.secondOcFreghtTerms;
          element.secondBLupload = element.secondBLupload;
          element.inputValue = element.inputValue;
          this.ffExoprtDetail.hbl_Arr.push(element);
        });
      }
      this.ffExoprtDetail.hblnew_Arr = JSON.stringify(this.ffExoprtDetail.hbl_Arr);
      let new_data = {
        ffExoprtDetail: this.ffExoprtDetail,
        HouseBLModel: this.HouseBLModel,
        ContainerDetail: this.ContainerTypeSizefactory,
        ContainerDetailType: this.ContainerTypeModel,
        checkBL: id,
      };
      // CUstom Validation Variable Declaration Start 23/06/2023
      this.validateFFImportCustomVali(); // Custom Validation 23/06/2023
      console.log("Priyanshu SIngh=>", this.validate);
      console.log("Priyanshu SIngh errorCustomValidation  =>", this.errorCustomValidation);
      console.log(
        "Priyanshu SIngh arrayErrorCustomValidation =>",
        this.arrayErrorCustomValidation
      );
      // return false;
      // CUstom Validation Variable Declaration End 23/06/2023
      if (this.validate != false) {
        if (id == "1") {
          $("#addButtonLoader").css("display", "none");
          $("#loader").css("display", "block");
        } else {
          $("#addButtonLoader3").css("display", "none");
          $("#loader3").css("display", "block");
        }
        // console.log("Priyanshu SIngh=>", new_data);
        // return false;

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/addNormalSeaImport.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              if (this.$sessionsStorage.get("editffSeaImportId") != "") {
                this.$sessionsStorage.set(
                  "editffSeaImportId",
                  this.ffExoprtDetail.ffImportId
                );
              } else {
                this.$sessionsStorage.set("editffSeaImportId", data.ffImportId);
              }
              if (id == "1") {
                $("#loader").css("display", "none");
                $("#addButtonLoader").css("display", "block");
              } else {
                $("#loader3").css("display", "none");
                $("#addButtonLoader3").css("display", "block");
              }

              if (this.ffExoprtDetail.ffImportId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }

              if (id == 1) {
                this.$refs["alertAddSeaImp"].open();
              } else if (id == "0") {
                this.$refs["message"].open();
              } else if (id == 5) {
                Object.keys(this.ContainerTypeModel).map((x) => {
                  this.ContainerTypeModel[x] = "";
                });
                this.getData();
              } else if (id == 2) {
                Object.keys(this.ContainerTypeSizefactory).map((x) => {
                  this.ContainerTypeSizefactory[x] = "";
                });
                this.openContainer = false;
                this.getData();
              } else {
                Object.keys(this.HouseBLModel).map((x) => {
                  this.HouseBLModel[x] = "";
                });
                this.openShipper = false;
                this.getData();
              }
            }
          })
          .catch((error) => {});
      }
    },

    submitNote() {
      this.isLoading = true;
      this.ShowSendApproval = false;
      if (this.noteParticulars.length <= 0) {
        this.alert.content = "Please add particulars";
        this.$refs["addPop"].open();
        return false;
      }

      let noteParti = [];
      let noteAmt = [];

      for (let i = 0; i < this.noteParticulars.length; i++) {
        noteParti.push(this.noteParticulars[i].parti);
        noteAmt.push(this.noteParticulars[i].amt ? this.noteParticulars[i].amt : 0);
      }
      this.noteModal.noteContent = noteParti.toString();
      this.noteModal.noteAmount = noteAmt.toString();
      let containerNoArryNote = [];
      this.containerTypeDetailFactory.map((x) => {
        containerNoArryNote.push(x.containerNo);
      });

      this.noteModal["containerNoArryNote"] = containerNoArryNote.toString();
      this.noteModal["noteParticulars"] = this.noteParticulars;
      this.noteModal["allModuleId"] = this.allModuleId;
      this.noteModal["agentName"] = "";
      this.noteModal["agentAddress"] = "";
      this.noteModal["vesselVoy"] = "";
      this.noteModal["shipper"] = "";
      this.noteModal["consignee"] = "";
      this.noteModal["fclBlId"] = this.noteModal.fclBlId;
      //  this.noteModal["branchName"] = this.PlaceListNew;
      this.noteModal["FinalPlace"] = "";
      this.noteModal["masterorLinerBlNo"] = this.noteModal.linerBLNumber;
      //  this.noteModal["BLNumber"] = this.BLRaised.billLading + this.noteModal.fclBlId;
      //       this.noteModal["salesSeries"] =
      //         this.BLRaised.ffExportFclConsoSeries;
      // this.noteModal["salesSeriesUpload"] =
      //       this.BLRaised.ffExportFclConsoSeries.replaceAll("/", "_");

      this.noteModal["ffExportFclId"] = this.$sessionsStorage.get("editffSeaImportId");
      // if (this.validate != false) {
      // console.log(this.noteModal.allModuleId,this.allModuleId,"this.BLRaised.placeBranch", this.$sessionsStorage.get("editffFclConsoExportId"));
      let obj = {
        noteContent: noteParti.toString(),
        noteAmount: noteAmt.toString(),
        allModuleId: this.noteModal.allModuleId,
        containerNoArryNote: this.containerNo,
        noteParticulars: this.noteParticulars,
        agentName: this.ffExoprtDetail.agentName,
        agentAddress: "test",
        vesselVoy: this.vesselVoyage,
        shipper: this.CLIENTNAME,
        consignee: 0,
        fclBlId: 0,
        branchName: this.user_baselocation,
        FinalPlace: this.ffExoprtDetail.finalPlaceDelivery,
        masterorLinerBlNo: "",
        BLNumber: 0,
        salesSeries: this.JOBSERIES,
        salesSeriesUpload: this.JOBSERIES.replaceAll("/", "_"),
        ffExportFclId: this.$sessionsStorage.get("editffSeaImportId"),
        remarks: this.noteModal.remarks,
        noteDate: this.noteModal.noteDate,
        note_id: this.note_id,
        page: "ffseaimport",
        creditDebitNoteType: this.noteModal.creditDebitNoteType,
        AgentColoader: this.noteModal.AgentColoader,

        // containerNoArryNote:'',
      };
      // console.log(obj);
      // console.log(this.BLRaised)
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/addCreditDebitNoteNew.php`,
        data: JSON.stringify(obj),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          // console.log(result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.noteModal.approvalStatus = "";
            this.noteModal.sentForApproval = "";
            this.noteContent = "";
            this.noteAmount = "";
            this.note_id = "";
            this.noteModal.remarks = "";
            this.noteModal.AgentColoader = "";

            if (data.msg == "Inserted Successfully") {
              this.alert.content = "Data Added Successfully";
            } else {
              this.alert.content = "Data Updated Successfully";
            }

            Object.keys(this.noteModal).map((x) => {
              this.noteModal[x] = "";
            });
            this.noteParticulars = [];

            this.$refs["note-modal"].hide();
            this.$refs["addPop"].open();
            // this.getData()
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log(`erroe`, error);
        });
      // }
    },
    getNoteData(noteTypeId) {
      const data = {
        allModuleId: this.allModuleId,
        categoryType: "NoteData",
        noteTypeId: noteTypeId,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getNoteData.php`,
        data: JSON.stringify(data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options).then((result) => {
        const { statusText, status, data } = result;
        // console.log(data);
        if (data.list.length > 0) {
          this.noteModal.approvalStatus = data.list[0].approvalStatus;
          this.noteModal.sentForApproval = data.list[0].sentForApproval;
          this.noteContent = data.list[0].noteContent;
          this.noteModal.uploadCreditDebit = data.list[0].uploadCreditDebit;
          this.noteAmount = data.list[0].noteAmount;
          this.note_id = data.list[0].note_id;
          this.noteModal.remarks = data.list[0].remarks;
          this.noteModal.AgentColoader = data.list[0].AgentColoader;
          this.noteModal.noteDate = data.list[0].noteDate;
        }
      });
    },
    getAgentColoaderList() {
      let type_Size = {
        view: "jdjd",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/getAgentColoaderList.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options).then((result) => {
        const { statusText, status, data } = result;
        if (status == 200 && data) {
          this.AgentColoaderList = data.agentColoaderList;
        }
      });
    },
    getData() {
      this.doLoading();
      let array = [];
      this.multiContainer = [];

      let vehicle_drive = {
        itemCode: "itemCode",
        ffImportId: this.$sessionsStorage.get("editffSeaImportId"),
      };
      1;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/getDataNormalSeaImport1.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          // console.log(data);
          if (status == 200 && data) {
            let containerNo = [];
            let containerType = [];
            let railOutDate = [];
            let arrivalDate = [];
            let freeDays = [];
            
            if (data.CommodityData_new.length > 0) {
              // this.getCommodityData = data.CommodityData;
              this.getCommodityData = data.CommodityData_new;
            } else {
              this.getCommodityData = [];
            }
            
            let otherNewContainerFLow = "0";
            if (data.ffSeaImportData.length > 0) {
              data.clientdetail.forEach((c) => {
                if (c.clientId == data.ffSeaImportData[0].importerClientId) {
                  this.CLIENTNAME = c.clientName;
                }
              });
              this.prbr_id = data.ffSeaImportData[0].prbr_id;
              this.ALLMODULE = data.ffSeaImportData[0].allModuleId;
              this.allModuleId = data.ffSeaImportData[0].allModuleId;
              this.JOBSERIES = data.ffSeaImportData[0].ffImportSeries;
              this.assignmentNo = data.ffSeaImportData[0].ffImportSeries;
              this.vesselVoyage = data.ffSeaImportData[0].vesselVoyage;
              this.containerNo = data.ffSeaImportData[0].containerNo;
              this.pickupLocation = data.ffSeaImportData[0].addedBy_user_baseLocation;
              this.ffExoprtDetail.otherNewContainerFLow =
                data.ffSeaImportData[0].otherNewContainerFLow;
              otherNewContainerFLow = data.ffSeaImportData[0].otherNewContainerFLow;
              if (
                data.ffSeaImportData[0].finalPlaceLocationId !=
                data.ffSeaImportData[0].PODLocationId
              ) {
                this.showLocalIgmDiv = true;
              }
              this.ffExoprtDetail.notifyList = [];
              
              // Object.keys(data.ffSeaImportData[0]).map((x) => {
              //   if (x == "notifyList") {
              //     console.log(x,data.ffSeaImportData[0][x], "oooo");
              //     data.ffSeaImportData[0][x].split("$$$").map((y, index) => {
              //       let obj = {
              //         inputValue: y,
              //         text: this.notifyListArray[index],
              //       };

              //       this.ffExoprtDetail.notifyList.push(obj);
              //     });
              //   } else if (x == "ContainerNo") {
              //     if (data.ffSeaImportData[0][x] != null) {
              //       containerNo = data.ffSeaImportData[0][x].split(",") || [];
              //     } else {
              //       containerNo = [];
              //     }
              //     // console.log(data);
              //   } else if (x == "ContainerType") {
              //     if (data.ffSeaImportData[0][x] != null) {
              //       containerType = data.ffSeaImportData[0][x].split(",") || [];
              //     } else {
              //       containerType = [];
              //     }
              //     // console.log(data);
              //   } else if (x == "railOutDate") {
              //     if (data.ffSeaImportData[0][x] != null) {
              //       railOutDate = data.ffSeaImportData[0][x].split(",") || [];
              //     } else {
              //       railOutDate = [];
              //     }
              //   } else if (x == "arrivalDate") {
              //     if (data.ffSeaImportData[0][x] != null) {
              //       arrivalDate = data.ffSeaImportData[0][x].split(",") || [];
              //     } else {
              //       arrivalDate = [];
              //     }
              //   } else if (x == "freeDays") {
              //     if (data.ffSeaImportData[0][x] != null) {
              //       freeDays = data.ffSeaImportData[0][x].split(",") || [];
              //     } else {
              //       freeDays = [];
              //     }
              //   } else {
              //     this.ffExoprtDetail[x] =
              //       data.ffSeaImportData[0][x] == "0"
              //         ? ""
              //         : data.ffSeaImportData[0][x] || "";
              //   }
              // });
            Object.keys(data.ffSeaImportData[0]).map((x) => {
              if (x === "notifyList") {
                // Check if notifyList is null or undefined
                if (data.ffSeaImportData[0][x]) {
                  console.log(x, data.ffSeaImportData[0][x], "oooo");
                  data.ffSeaImportData[0][x].split("$$$").map((y, index) => {
                    let obj = {
                      inputValue: y,
                      text: this.notifyListArray[index] || "", // Ensure text has a fallback
                    };

                    this.ffExoprtDetail.notifyList.push(obj);
                  });
                } else {
                  // Handle null/undefined notifyList
                  console.log(x, "null oooo");
                  this.ffExoprtDetail.notifyList = []; // Set an empty array when null
                }
              } else if (x === "ContainerNo") {
                // Handle null/undefined for ContainerNo
                containerNo = data.ffSeaImportData[0][x] ? data.ffSeaImportData[0][x].split(",") : [];
              } else if (x === "ContainerType") {
                // Handle null/undefined for ContainerType
                containerType = data.ffSeaImportData[0][x] ? data.ffSeaImportData[0][x].split(",") : [];
              } else if (x === "railOutDate") {
                // Handle null/undefined for railOutDate
                railOutDate = data.ffSeaImportData[0][x] ? data.ffSeaImportData[0][x].split(",") : [];
              } else if (x === "arrivalDate") {
                // Handle null/undefined for arrivalDate
                arrivalDate = data.ffSeaImportData[0][x] ? data.ffSeaImportData[0][x].split(",") : [];
              } else if (x === "freeDays") {
                // Handle null/undefined for freeDays
                freeDays = data.ffSeaImportData[0][x] ? data.ffSeaImportData[0][x].split(",") : [];
              } else {
                // Handle other fields
                this.ffExoprtDetail[x] = data.ffSeaImportData[0][x] && data.ffSeaImportData[0][x] !== "0"
                  ? data.ffSeaImportData[0][x]
                  : "";
              }
            });

              console.log("Priyanshu SIngha ffSeaImportData=>", data);
              // alert(this.ffExoprtDetail.otherNewContainerFLow)
              if (containerType.length > 0) {
                // console.log("ppp");
                containerType.map((x, index) => {
                  let obj = {
                    ContainerType: x,
                    ContainerNo: containerNo[index],
                    railOutDate: railOutDate[index],
                    arrivalDate: arrivalDate[index],
                    freeDays: freeDays[index],
                  };

                  this.multiContainer.push(obj);
                });
              }
              // console.log(this.multiContainer);
            }
            
            if (data.agentColoaderData.length > 0) {
              this.getagentName = data.agentColoaderData.filter((x) => {
                return x.categoryType == "Agent";
              });

              this.getColoaderName = data.agentColoaderData.filter((x) => {
                return x.categoryType == "CoLoader";
              });
            }
            if (data.ccContainerDetails.length > 0) {
              this.ccContainers = data.ccContainerDetails[0].ContainerNo;
              //   this.multiContainer.ContainerNo.push();
            }
            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            }

            if (otherNewContainerFLow == 0) {
              if (data.getHouseBLData.length > 0) {
                this.getHouseBLData = data.getHouseBLData;
              }
            } else if (otherNewContainerFLow == 1) {
              console.log("Priyanshu SIngh=>", data);
              // alert(data.ffSeaImportData[0].getHouseBLData.length+"Happy")
              if (data.ffSeaImportData[0].getHouseBLData.length > 0) {
                this.getHouseBLData = data.ffSeaImportData[0].getHouseBLData;
                // console.log("this.getHouseBLData=>",this.getHouseBLData)
                // alert(data.ffSeaImportData[0].master_linerBLNumber)
                this.ffExoprtDetail.firstBLNumber =data.ffSeaImportData[0].master_linerBLNumber;
              }
            }
            if (data.multiContainerData.length > 0) {
              this.getContainerList = data.multiContainerData;
            }
            if (data.multiContainerTypeData.length > 0) {
              this.getContainerTypeList = data.multiContainerTypeData;
              this.getContainerTypeFinal = data.multiContainerTypeFinal;
            } else {
              this.getContainerTypeList = [];
              this.getContainerTypeFinal = [];
            }

            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            }
            if (data.containerMaster.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            }

            if (data.packageMaster.length > 0) {
              this.packageMaster = data.packageMaster;
            }
            
            this.getAgentColoaderList();
            const vehicle_drive = {
              categoryType: "hel",
            };
            let options = {
              method: "POST",
              url: `${URL_BASE}/getLocationList.php`,
              data: JSON.stringify(vehicle_drive),
              crossDomain: true,
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: this.$sessionsStorage.get("loginId"),
              },
            };

            axios(options).then((result) => {
              // console.log(result);
              const location = this.pickupLocation;
              const { statusText, status, data } = result;
              // console.log(data);
              data.userDataList.forEach((c) => {
                if (c.pickupId == location) {
                  this.user_baselocation = c.pickupLocation;
                }
              });
              // console.log(this.user_baselocation, location);
            });

            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },

    previousFFView() {
      this.$router.push({
        path: "/seaImport/viewSeaImportDetails",
      });
    },
    getServicesData() {
      this.showSegmentArray = [
        {
          value: "FF",
          show: "Freight Forwarding(FF)",
          flex: "20",
        },
        {
          value: "CC",
          show: "Customs Clearance(CC)",
          flex: "20",
        },
        {
          value: "TPT",
          show: "Transportation(TPT)",
          flex: "20",
        },

        // {
        //   value: "All",
        //   show: "All",
        //   flex: "15"
        // }
      ];
    },
    // Added By Priyanshu Singh Start
    openCommodityModal() {
      this.isLoading = false;
      this.$refs["Commodity-modal"].show();
    },
    hideCommodityModal() {
      this.$refs["Commodity-modal"].hide();
      this.isLoading = false;
    },
    validateCommodity() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.commodityModal[x] == "") {
          this.errorList[x] = this.CommodityError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addCommodity() {
      this.validateCommodity();
      if (this.validate != false) {
        this.commodityModal.type = "Normal";
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addCommodity_VP.php`,
          data: JSON.stringify(this.commodityModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              // alert(data.find);

              if (data.commodityNewId != "" && data.commodityNewId != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.commodityModal.commodityNewId = "";
                  this.commodityModal.itemName = "";
                  this.commodityModal.hsnCode = "";
                  if (data.CommodityData.length > 0) {
                    this.getCommodityData = data.CommodityData;
                  } else {
                    this.getCommodityData = [];
                  }
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.hideCommodityModal();
              // console.log("MyData=>", data);
              // console.log("Mystatus=>", status);
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {});
      }
    },
    // Added By Priyanshu Singh End
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.mx-calendar-content {
  width: auto;
  height: auto;
}
.mx-panel-date {
  table-layout: auto;
  border-collapse: collapse;
  border-spacing: 0;
}
</style>



// WEBPACK FOOTER //
// newFFseaImportFcl.vue?70a72faf